<template>
    <div class="page faq">

        <div class="page-header">
            <h2 class="page-heading">
                Frequently Asked Questions
            </h2>
        </div>

        <p>
            FAQ coming soon 😀🤷‍
        </p>




    </div>
</template>

<script>

    export default {
        name: 'faq',
        data: () => ({
        }),
        components: {
        },
        metaInfo() {
            return {
                title: "FAQ"
            }
        },
        computed: {
        },
        methods: {
        }
    }
</script>


<style scoped lang="scss">

    .page-header {
        h2 {
            margin: 0;
        }
        margin-bottom: 50px;
    }
    h3 {
        margin-bottom: 0;
        padding-bottom: 0;
    }
    p {
        margin-top: 0;
        padding-top: 0;
    }



</style>
